$('.dashboard__table-more').click(function() {
  $(this).toggleClass('show');
  $(this).children('.dropdown-menu').toggleClass('show');
})
